<template>
  <div class="table-class">
    <v-client-table
      @row-click="emitRowClick"
      :columns="columns"
      :data="tableData"
      :options="computedOptions"
    >
      <template :slot="order.headerName" v-for="order of orderBy">
        <div class="header-priority-wrapper" :key="order.headerName">
          <p style="margin-right: auto;">{{ order.name }}</p>
          <div class="header-priority-icons">
            <i
              v-if="sorted === order.order_condition && ordering === 'desc'"
              class="fas fa-sort-up"
              @click="emitSort(order.order_condition)"
            ></i>
            <i
              v-if="sorted === order.order_condition && ordering === 'asc'"
              class="fas fa-sort-down"
              @click="emitSort(order.order_condition)"
            ></i>
            <i
              v-if="sorted !== order.order_condition"
              class="fas fa-sort"
              @click="emitSort(order.order_condition)"
            ></i>
          </div>
        </div>
      </template>

      <!--slotovi za community home-->
      <a :slot="slotNameCommunityName" slot-scope="props" target="_blank">
        <div class="com-name">
          {{ props.row.name }}
          <notification-badge
            style="margin-left: 10px"
            :notificationNumber="
              $store.getters.getNumOfNotifications(props.row.id)
            "
            v-if="$store.getters.getNumOfNotifications(props.row.id) > 0"
          ></notification-badge>
        </div>
      </a>

      <div :slot="slotDateFrom" slot-scope="props">
        {{ props.row.dateFrom | formatDateTime }}
      </div>
      <div :slot="slotDateTo" slot-scope="props">
        {{ props.row.dateTo | formatDateTime }}
      </div>
      <div :slot="slotDateReminder" slot-scope="props">
        {{ props.row.date | formatDateTimeNoSeconds }}
      </div>

      <!--slotovi za notification table-->
      <div :slot="slotDate" slot-scope="props">
        {{ props.row.timestamp | formatDateTimeNoSeconds }}
      </div>
      <div :slot="slotProjectType" slot-scope="props">
        {{ props.row.type == 'TEMPORARY' ? 'Privremen' : 'Trajan' }}
      </div>
      <div :slot="slotProjectCompleted" slot-scope="props">
        {{ props.row.numberOfClosedTickets }}/{{
          props.row.numberOfCommunityProjects
        }}
      </div>

      <div :slot="slotDatePost" slot-scope="props">
        {{ props.row.time | formatDateTime }}
      </div>

      <a :slot="slotNotificationStatus" slot-scope="props" target="_blank">
        <div class="notification-status">
          <span v-if="props.row.is_read === '1'">
            Pročitano
            <i class="fas fa-check"></i>
          </span>
          <span v-else>
            Novo
            <i class="fas fa-exclamation-circle"></i>
          </span>
        </div>
      </a>

      <!--slotovi za tabelu clanova na cekanju-->
      <a :slot="slotNamePending" slot-scope="props" target="_blank">
        <div class="btn-wrapper">
          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="openModal('ModalContentMemberReject', props.row)"
          >
            Odbij
          </button>
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openModal('ModalContentMemberAccept', props.row)"
          >
            Prihvati
          </button>
        </div>
      </a>

      <!--slotovi za tabelu aktivnih clanova-->

      <a :slot="slotTotalPoints" slot-scope="props" target="_blank">
        <div class="cell">
          <status-bar :status="props.row.totalPoints"></status-bar>
        </div>
      </a>

      <a :slot="slotFullNameManager" slot-scope="props" target="_blank">
        <div class="manager-member">
          {{ props.row.user_full_name }}
          <status-bar
            class="manager-badge"
            v-if="props.row.is_manager == '1'"
            :status="'Upravnik'"
          ></status-bar>
        </div>
      </a>

      <a :slot="slotNameActive" slot-scope="props" target="_blank">
        <div class="btn-wrapper">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openModal('ModalContentMemberDetails', props.row)"
          >
            Detalji
          </button>
          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="openModal('ModalContentMemberEdit', props.row)"
          >
            Izmeni
          </button>
          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="openModal('ModalContentMemberRemove', props.row)"
          >
            Ukloni
          </button>
        </div>
      </a>

      <!--slotovi za reminder details-->
      <a :slot="slotNameReminderTicket" slot-scope="props" target="_blank">
        <div class="cell cell--mod" v-if="props.row.ticketId">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openReminderTicket(props.row.ticketId)"
          >
            Vidi tiket
          </button>
        </div>
      </a>

      <!--slotovi za projects tabelu-->
      <a :slot="slotNameProjects" slot-scope="props" target="_blank">
        <div class="cell cell--mod">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="emitRowClickEvent(props)"
          >
            Prikaži
          </button>
          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="openProjectModal('ModalContentDeleteProject', props.row)"
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slotovi za project details -> zaejdnice tabelu-->
      <a
        :slot="slotNameProjectDetialsCommunities"
        slot-scope="props"
        target="_blank"
      >
        <div class="cell cell--mod">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openTicketDetailsFromProjectDetails(props.row)"
          >
            Prikaži tiket
          </button>
        </div>
      </a>

      <!--slotovi za tabelu glasanja-->
      <a :slot="slotNameActionPoll" slot-scope="props" target="_blank">
        <div class="cell cell--mod">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openPollDetails(props.row)"
          >
            Prikaži
          </button>
          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="openPollModal('ModalContentPollEdit', props.row)"
          >
            Izmeni
          </button>
          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="openPollModal('ModalContentPollDelete', props.row)"
            v-show="isManager(props.row)"
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slotovi za tabelu dogadjaja-->
      <div
        class="cell cell--mod"
        :slot="slotNameActionEvent"
        slot-scope="props"
      >
        <button
          type="button"
          class="btn btn-primary btn--mod"
          @click="openEventDetails(props.row)"
        >
          Prikaži
        </button>
        <button
          type="button"
          class="btn btn--mod btn-table"
          @click="openEventModal('ModalContentEventEdit', props.row)"
        >
          Izmeni
        </button>
        <button
          type="button"
          class="btn btn-danger btn--mod"
          @click="openEventModal('ModalContentEventDelete', props.row)"
        >
          Obriši
        </button>
      </div>

      <!--slotovi za PIN postova-->
      <div class="cell post-pin" :slot="slotNamePostPin" slot-scope="props">
        <i v-if="props.row.is_pinned == '1'" class="fas fa-thumbtack"></i>
      </div>

      <!--slotovi za tabelu postova-->
      <div
        class="cell cell--mod--left"
        :slot="slotNameActionPost"
        slot-scope="props"
      >
        <button
          type="button"
          class="btn btn-primary btn--mod"
          @click="openPostDetails(props.row)"
        >
          Prikaži
        </button>
        <button
          type="button"
          class="btn btn--mod btn-table"
          @click="openPostModal('ModalContentPostEdit', props.row)"
        >
          Izmeni
        </button>
        <button
          type="button"
          class="btn btn-danger btn--mod"
          @click="openPostModal('ModalContentPostDelete', props.row)"
          v-show="isManager(props.row)"
        >
          Obriši
        </button>
      </div>

      <!--slotovi za tabelu tiketa-->
      <a
        :slot="slotNamePriority"
        slot-scope="props"
        target="_blank"
        @click="openTicketDetails(props.row)"
      >
        <div class="cell">
          <status-bar :status="props.row.priority_id"></status-bar>
        </div>
      </a>
      <a
        :slot="slotNameStatus"
        slot-scope="props"
        target="_blank"
        @click="openTicketDetails(props.row)"
      >
        <div class="cell">
          <status-bar :status="props.row.current_status"></status-bar>
        </div>
      </a>
      <a
        :slot="slotNamePrivacy"
        slot-scope="props"
        target="_blank"
        @click="openTicketDetails(props.row)"
      >
        <div class="cell">
          <status-bar
            v-if="props.row.privacy === '1'"
            status="Privatan"
            class="statbar"
          ></status-bar>
          <status-bar v-else status="Javan" class="statbar"></status-bar>
        </div>
      </a>
      <a
        :slot="slotNameAction"
        slot-scope="props"
        target="_blank"
        class="center-content"
      >
        <div class="cell cell--mod--left">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openTicketDetails(props.row)"
          >
            Prikaži
          </button>
          <!-- <button
            type="button"
            class="btn btn--mod btn-table"
            @click="openTicketModal('ModalContentTicketEdit', props.row)"
          >
            Izmeni
          </button> -->

          <button
            v-if="isSuperManager"
            type="button"
            class="btn btn-danger btn--mod"
            @click="openTicketModal('ModalContentTicketDelete', props.row)"
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slot za tabelu communityDocuments-->
      <a
        :slot="slotNameActionCommunityDocuments"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <div class="cell cell--mod">
          <a
            type="button"
            class="btn btn-primary btn--mod"
            target="_blank"
            :href="baseObjectStorageUrl + props.row.link"
          >
            Otvori
          </a>

          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="deleteDocument('ModalContentDocumentDelete', props.row)"
          >
            Obriši
          </button>
        </div>
      </a>
      <!--slot za tabelu community reminders-->
      <a
        :slot="slotNameActionCommunityReminders"
        class="center-content"
        slot-scope="props"
      >
        <div class="cell cell--mod">
          <button
            type="button"
            class="btn btn-primary btn--mod"
            @click="openReminderDetails(props.row)"
          >
            Prikaži
          </button>
          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="openEditReminder(props.row)"
            v-if="props.row.type != 'dashboard'"
          >
            Izmeni
          </button>

          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="openDeleteReminder(props.row)"
            v-if="props.row.type != 'dashboard'"
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slot za tabelu AllContractors-->
      <a
        :slot="slotNameActionCommunityContractors"
        class="center-content"
        slot-scope="props"
      >
        <div class="cell cell--mod">
          <a
            type="button"
            class="btn btn-primary btn--mod"
            :href="'/#/contractor/' + props.row.id"
          >
            Prikaži
          </a>

          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="
              openEditContractorModal('ModalContentEditContractor', props.row)
            "
          >
            Izmeni
          </button>

          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="
              openDeleteContractorModal(
                'ModalContentDeleteContractor',
                props.row
              )
            "
          >
            Obriši
          </button>
        </div>
      </a>
      <!--slot za tabelu AllInfrastructures-->
      <a
        :slot="slotNameActionCommunityIntrastructures"
        class="center-content"
        slot-scope="props"
      >
        <div class="cell cell--mod">
          <a
            type="button"
            class="btn btn-primary btn--mod"
            :href="
              '/#/community/' +
                activeCommunityId +
                '/infrastructure/' +
                props.row.id
            "
          >
            Detalji
          </a>
          <!-- 
          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="
              openEditInfrastructureModal(
                'ModalContentEditCommunityInfrastructure',
                props.row
              )
            "
          >
            Izmeni
          </button> -->

          <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="
              openDeleteInfrastructureModal(
                'ModalContentDeleteCommunityInfrastructure',
                props.row
              )
            "
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slot za tabelu allReminders-->
      <a :slot="slotNextInstance" class="center-content" slot-scope="props">
        <div class="cell cell--mod">
          {{ props.row.nextInstance | formatDateTimeNoSeconds }}
        </div>
      </a>
      <!--slot za tabelu allProperties-->
      <a
        :slot="slotNameActionCommunityProperties"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <div class="cell cell--mod">
          <a
            type="button"
            class="btn btn-primary btn--mod"
            :href="
              '/#/community/' + activeCommunityId + '/property/' + props.row.id
            "
          >
            Detalji
          </a>

          <button
            type="button"
            class="btn btn--mod btn-table"
            @click="openEditProperty('ModalContectEditProperty', props.row)"
          >
            Izmeni
          </button>

          <!-- <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="deleteDocument('ModalContentDocumentDelete', props.row)"
          >
            Obriši
          </button> -->
        </div>
      </a>
      <!--slot za tabelu allUsers-->
      <a
        :slot="slotNameActionAllUsers"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <div class="cell cell--mod">
          <!-- TODO: Change href -->
          <a
            type="button"
            class="btn btn-primary btn--mod"
            :href="'/#/user/' + props.row.id"
          >
            Detalji
          </a>

          <!-- TODO: Add @click -->
          <!-- <button type="button" class="btn btn--mod btn-table">
            Izmeni
          </button> -->

          <!-- TODO: Add @click -->
          <!-- <button
            type="button"
            class="btn btn-danger btn--mod"
            @click="deleteDocument('ModalContentDocumentDelete', props.row)"
          >
            Obriši
          </button> -->
        </div>
      </a>
      <!--slot za tabelu communityFinances-->
      <a
        :slot="slotNameActionCommunityFinances"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <div class="cell cell--mod">
          <button
            type="button"
            class="btn btn-primary btn--mod btn-finances-details"
            @click="openMemberDetails(props.row)"
          >
            Detalji
          </button>

          <button
            type="button"
            class="btn btn-default btn--mod btn-finances-details btn-table"
            @click="
              openVirtualMemberEditModal(
                'ModalContentVirtualMemberEdit',
                props.row
              )
            "
          >
            Izmeni
          </button>

          <button
            type="button"
            class="btn btn-danger btn--mod btn-finances-details"
            @click="
              deleteVirtualMmeber('ModalContentVirtualMemberDelete', props.row)
            "
          >
            Obriši
          </button>
        </div>
      </a>

      <!--slot za tabelu communityFinancesTransactions-->
      <a
        :slot="slotNameActionCommunityFinancesTransactions"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <button
          type="button"
          class="btn btn--mod btn-table"
          @click="openTransactionEditModal(props.row)"
        >
          Izmeni
        </button>
        <button
          type="button"
          class="btn btn-danger btn--mod"
          @click="
            openTransactionModal('ModalContentDeleteTransaction', props.row)
          "
        >
          Obriši
        </button>
      </a>

      <!--slot za tabelu communityFinancesExpenses-->
      <a
        :slot="slotNameActionCommunityFinancesExpenses"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <button
          type="button"
          class="btn btn--mod btn-table"
          @click="openExpenseModal('ModalContentExpenseEdit', props.row)"
        >
          Izmeni
        </button>
        <button
          type="button"
          class="btn btn-danger btn--mod"
          @click="openExpenseModal('ModalContentExpenseDelete', props.row)"
        >
          Obriši
        </button>
      </a>

      <!--slot za tabelu communityFinancesInvoices-->
      <div
        :slot="slotNameActionCommunityFinancesInvoices"
        class="center-content"
        slot-scope="props"
        target="_blank"
      >
        <!-- <button type="button" class="btn btn--mod">Izmeni</button> -->
        <button
          type="button"
          class="btn btn-default btn--mod btn-table"
          @click="$emit('invoicesPdfClick', props)"
        >
          <spinner
            :size="20"
            line-fg-color="#00796b"
            v-if="props.row.isLoading"
          />
          <i v-else class="fas fa-file-download"></i>
        </button>
        <button
          type="button"
          class="btn btn-default btn--mod btn-table"
          @click="$emit('invoicesEmailClick', props)"
        >
          <i class="far fa-envelope"></i>
        </button>
        <button
          type="button"
          class="btn btn-primary btn--mod"
          @click="
            openInvoiceModal('ModalContentInvoicePreview', props.row, true)
          "
        >
          Prikaži
        </button>
        <button
          type="button"
          class="btn btn-danger btn--mod"
          @click="openInvoiceModal('ModalContentInvoiceDelete', props.row)"
        >
          Obriši
        </button>
      </div>

      <!-- slot za amount -->
      <template
        :slot="slotTransactionsAmount"
        slot-scope="props"
        target="_blank"
      >
        <div :class="getAmountClass(props.row)">
          {{ props.row.amount | addSeparator }}
        </div>
      </template>

      <!-- slot za state -->
      <template
        :slot="slotTransactionsBalance"
        slot-scope="props"
        target="_blank"
      >
        <div :class="getBalanceClass(props.row)">
          {{ props.row.balance | addSeparator }}
        </div>
      </template>

      <!-- slot za price -->
      <template :slot="slotExpensePrice" slot-scope="props" target="_blank">
        <div>{{ props.row.price | addSeparator }}</div>
      </template>

      <!-- slot za total_price -->
      <template
        :slot="slotInvoiceTotalAmount"
        slot-scope="props"
        target="_blank"
      >
        <div>{{ props.row.total_amount | addSeparator }}</div>
      </template>

      <!-- slot za income -->
      <template
        :slot="slotTransactionsIncome"
        slot-scope="props"
        target="_blank"
      >
        <div class="table-transaction-income">
          {{ props.row.income | addSeparator }}
        </div>
      </template>

      <!-- slot za expense -->
      <template
        :slot="slotTransactionsExpense"
        slot-scope="props"
        target="_blank"
      >
        <div class="table-transaction-expense">
          {{ props.row.expense | addSeparator }}
        </div>
      </template>
    </v-client-table>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import TicketStatusBadge from '../common/TicketStatusBadge.vue';
import NotificationBadge from '@/components/common/NotificationBadge.vue';
import axios from '@/axios/axios.js';
import {
  addSeparatorMixin,
  formatDateMixin,
  formatDateNoSecondsMixin
} from '@/mixins/mixins.js';
import { UserRoles } from '@/util/UtilService.js';
export default {
  props: {
    columns: { type: Array, required: true },
    tableData: { type: Array, required: true },
    options: { type: Object, required: true },

    // props za nazive kolona tabelakoje gadjaju slotovi
    slotNamePending: { type: String },
    slotNameActive: { type: String },
    slotNamePriority: { type: String },
    slotNameStatus: { type: String },
    slotNamePrivacy: { type: String },
    slotNameAction: { type: String },
    slotNameActionPoll: { type: String },
    slotNameProjects: { type: String },
    slotNameProjectDetialsCommunities: { type: String },
    slotNameReminderTicket: { type: String },
    slotNameActionEvent: { type: String },
    slotNameActionPost: { type: String },
    slotNamePostPin: { type: String },
    slotNameCommunityName: { type: String },
    slotNotificationStatus: { type: String },
    slotNameActionCommunityDocuments: { type: String },
    slotNameActionCommunityReminders: { type: String },
    slotNameActionCommunityContractors: { type: String },
    slotNameActionCommunityIntrastructures: { type: String },
    slotNameActionCommunityProperties: { type: String },
    slotNextInstance: { type: String },
    slotNameActionCommunityFinances: { type: String },
    slotNameActionCommunityFinancesTransactions: { type: String },
    slotNameActionCommunityFinancesInvoices: { type: String },
    slotNameActionCommunityFinancesExpenses: { type: String },
    slotNameActionAllUsers: { type: String },
    slotTransactionsAmount: { type: String },
    slotTransactionsBalance: { type: String },
    slotExpensePrice: { type: String },
    slotInvoiceTotalAmount: { type: String },
    slotTransactionsIncome: { type: String },
    slotTransactionsExpense: { type: String },
    slotTotalPoints: { type: String },
    slotFullNameManager: { type: String },
    slotDate: { type: String },
    slotDateFrom: { type: String },
    slotDateTo: { type: String },
    slotDatePost: { type: String },
    slotDateReminder: { type: String },
    slotProjectType: { type: String },
    slotProjectCompleted: { type: String },
    hideDefaultSort: { type: Boolean }
  },
  mixins: [addSeparatorMixin, formatDateMixin, formatDateNoSecondsMixin],
  components: {
    statusBar: TicketStatusBadge,
    NotificationBadge: NotificationBadge
  },
  data() {
    return {
      activeCommunityId: this.$store.getters.getActiveCommunity.id,
      baseObjectStorageUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      sorted: '',
      ordering: 'asc',
      search: '',
      orderBy: [
        {
          headerName: 'h__priority_id',
          name: 'Prioritet',
          order_condition: 'priority'
        }
        // { headerName: 'h__title', name: 'Naslov', order_condition: 'name' }

        // {
        //   headerName: 'h__current_status',
        //   name: 'Status',
        //   order_condition: 'status'
        // }
      ],
      defaultOptions: {
        filterable: true,
        sortIcon: {
          base: 'fas',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
          is: 'fa-sort'
        },
        texts: {
          filter: '',
          filterPlaceholder: 'Pretraži',
          count: '',
          noResults: 'Nema rezultata za željenu zajednicu'
        },
        pagination: {
          dropdown: false,
          chunk: 10,
          edge: false,
          align: 'center',
          nav: 'fixed'
        },
        perPage: 10
      },
      isSuperManager: false
    };
  },
  created() {
    if (this.hideDefaultSort) {
      this.orderBy = [];
    }
    this.isSuperManager =
      this.$store.getters.getUser.roles.indexOf(UserRoles.SUPER_MANAGER) != -1;
  },
  computed: {
    computedOptions() {
      const mergedOptions = {
        //merge i pregazice options defaultOptions ako postoji taj slucaj
        ...this.defaultOptions,
        ...this.options
      };
      if (this.options.perPage) {
        mergedOptions.perPage = this.options.perPage;
      }
      return mergedOptions;
    }
  },
  getCommunities() {
    return this.$store.state.communities;
  },
  methods: {
    ...mapMutations('modal', [
      'showModal',
      'showModalWider',
      'setMember',
      'setVirtualMember',
      'setDocument',
      'setUserList',
      'setTicket',
      'setPoll',
      'setEvent',
      'setPost',
      'setTransaction',
      'setExpense',
      'setInvoice',
      'setProperty',
      'setInfrastructure',
      'setContractor',
      'setProject'
    ]),
    ...mapMutations('ticket', ['setBasicInfo']),
    ...mapMutations(['setActiveCommunity', 'setPostTitle']),
    ...mapMutations('table', ['setRestructuredTableData', 'unsetTableData']),
    ...mapMutations('poll', ['setBasicPollInfo']),
    ...mapActions('poll', ['getPollDetails']),
    ...mapMutations('event', ['setBasicEventInfo', 'setEventDetails']),
    ...mapActions('event', ['getEventComments', 'getEventAttendancePoll']),
    ...mapActions('post', ['setBasicPostInfo']),
    ...mapActions('table', ['getReminderById']),

    isManager(e) {
      if (this.$router.history.current.name == 'communityPolls') {
        return e.authorId == this.$store.getters.getActiveCommunity.member_id;
      } else {
        let community = this.$store.getters.getCommunities.filter(
          c => c.community_id == e.communityId
        );
        if (community[0]) {
          return community[0].member_id == e.authorId;
        }
      }
      return false;
    },
    getStatStyle(status) {
      switch (status) {
        case 'Nov':
          return 'btn--new';
        case 'Otvoren':
          return 'btn--opened';
        case 'U toku':
          return 'btn--in-progress';
        case 'Zatvoren':
          return 'btn--high';
        case 'Nizak':
          return 'btn--low';
        case 'Srednji':
          return 'btn--medium';
        case 'Visok':
          return 'btn--high';
        default:
          return '';
      }
    },
    openReminderTicket(ticketId) {
      this.$router.push({
        name: 'ticketDetails',
        params: {
          ticketId: ticketId
        }
      });
    },
    openTicketDetails(e) {
      this.setPostTitle(e.title);
      this.setBasicInfo({
        memberId: e.member_id,
        ticketId: e.id,
        title: e.title
      });
      if (this.$router.history.current.name === 'tickets') {
        this.setActiveCommunity(e.community_id);
      }
      this.$router.push({
        name: 'ticketDetails',
        params: {
          ticketId: e.id
        }
      });
    },
    openTicketDetailsFromProjectDetails(community) {
      if (this.$store.getters.getActiveCommunity.community_id != community.id) {
        this.setActiveCommunity(community.id);
        const activeCommunity = this.$store.getters.getActiveCommunity;
        const name = `${activeCommunity.address} ${
          activeCommunity.street_number
        }, ${activeCommunity.municipality_name}`;
        this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
      }
      this.setBasicInfo({
        ticketId: community.ticketId
      });
      this.$router.push({
        name: 'ticketDetails',
        params: {
          ticketId: community.ticketId
        }
      });
    },
    openPollDetails(e) {
      if (this.$router.history.current.name === 'polls') {
        this.setActiveCommunity(e.communityId);
      }
      // this.setPostTitle(e.body);
      this.setPostTitle('Glasanje');

      this.setBasicPollInfo({
        memberId: e.authorId,
        pollId: e.id,
        title: e.body,
        active: e.active
      });
      // this.getPollDetails();
      this.$router.push({
        name: 'pollDetails',
        params: {
          pollId: e.id
        }
      });
    },
    openEventDetails(e) {
      if (this.$router.history.current.name === 'events') {
        this.setActiveCommunity(e.communityId);
      }
      // this.setPostTitle(e.body);
      this.setPostTitle('Događaj');
      this.setBasicEventInfo(e);
      this.setEventDetails(e);

      this.getEventComments();
      this.getEventAttendancePoll();

      this.$router.push({
        name: 'eventDetails',
        params: {
          eventId: e.postId
        }
      });
    },
    openPostDetails(e) {
      if (this.$router.history.current.name === 'posts') {
        this.setActiveCommunity(e.communityId);
      }
      this.setPostTitle('Detalji objave');
      this.setBasicPostInfo({
        post: e
      });
      this.$router.push({
        name: 'communityPostDetails',
        params: {
          postId: e.postId
        }
      });
    },
    openModal(name, e) {
      e.full_name = e.user_full_name;
      this.setMember(e);
      this.showModal(name);
    },
    openTicketModal(name, e) {
      //tiket za koji se vrse izmene
      this.setTicket(e);
      this.showModal(name);
    },
    openPollModal(name, e) {
      this.setPoll(e);
      this.showModal(name);
    },
    openEventModal(name, e) {
      this.setEvent(e);
      this.showModal(name);
    },
    openPostModal(name, e) {
      this.setPost(e);
      this.showModal(name);
    },
    openProjectModal(name, data) {
      this.setProject({
        project: data
      });
      this.showModal(name);
    },
    openTransactionModal(name, e) {
      this.setTransaction(e);
      this.showModal(name);
    },
    openTransactionEditModal(e) {
      this.setTransaction(e);
      if (e.amount > 0) {
        this.showModal('ModalContentEditTransactionIncome');
      } else {
        this.showModal('ModalContentEditTransactionPayout');
      }
    },
    openExpenseModal(name, e) {
      this.setExpense(e);
      this.showModal(name);
    },
    openInvoiceModal(name, e, wider = false) {
      this.setInvoice(e);
      if (wider) {
        this.showModalWider(name);
      } else {
        this.showModal(name);
      }
    },

    emitRowClick(e) {
      //button click will handle action
      if (e.event.target.tagName == 'I' || e.event.target.tagName == 'BUTTON') {
        return;
      }
      switch (e.row.dataType) {
        case 'ticket':
          this.openTicketDetails(e.row);
          break;
        case 'ticket-contractor':
          if (
            this.$store.getters.getActiveCommunity.community_id !=
            e.row.community_id
          ) {
            this.setActiveCommunity(e.row.community_id, true);
            const community = this.$store.getters.getActiveCommunity;
            const name = `${community.address} ${community.street_number}, ${
              community.municipality_name
            }`;
            this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
          }
          this.openTicketDetails(e.row);
          break;
        case 'event':
          this.openEventDetails(e.row);
          break;
        case 'member':
          this.openModal('ModalContentMemberDetails', e.row);
          break;
        case 'poll':
          this.openPollDetails(e.row);
          break;
        case 'virtualMember':
          this.openMemberDetails(e.row);
          break;
        case 'invoice':
          this.openInvoiceModal('ModalContentInvoicePreview', e.row, true);
          break;
        case 'post':
          this.openPostDetails(e.row);
          break;
        default:
          this.$emit('row-click', e);
      }
    },
    emitRowClickEvent(e) {
      this.$emit('row-click', e);
    },
    getMemberDetails(name, e) {
      axios
        .post('member/get-member-info', {
          member_id: e.id
        })
        .then(({ data }) => {
          this.setMember(data);
          this.showModal(name);
        })
        .catch(err => {
          console.log(err);
        });
    },
    openMemberDetails(e) {
      this.$router.push({
        name: 'communityFinancesMember',
        params: {
          memberId: e.id
        }
      });
    },
    openVirtualMemberEditModal(modalName, virtualMember) {
      this.setVirtualMember(virtualMember);
      this.showModal(modalName);
    },
    deleteVirtualMmeber(modalName, virtualMember) {
      this.setVirtualMember(virtualMember);
      this.setUserList(this.tableData);
      this.showModal(modalName);
    },
    openEditProperty(modalName, property) {
      this.setProperty(property);
      this.showModal(modalName);
    },
    openEditInfrastructureModal(modalName, property) {
      this.setInfrastructure(property);
      this.showModal(modalName);
    },
    openDeleteInfrastructureModal(modalName, property) {
      this.setInfrastructure(property);
      this.showModal(modalName);
    },
    openEditContractorModal(modalName, contractor) {
      this.setContractor(contractor);
      this.showModal(modalName);
    },
    openDeleteContractorModal(modalName, contractor) {
      this.setContractor(contractor);
      this.showModal(modalName);
    },
    deleteDocument(modalName, document) {
      this.setDocument(document);
      this.showModal(modalName);
    },
    openReminderDetails(data) {
      if (data.communityId != this.$store.getters.getActiveCommunity.id) {
        this.$store.commit('setActiveCommunity', data.communityId);
        const community = this.$store.getters.getCommunities.find(
          c => c.community_id == data.communityId
        );
        const name = community.address + ' ' + community.street_number;
        this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
      }
      this.$router.push({
        name: 'communityReminderDetails',
        params: {
          id: data.communityId,
          reminderId: data.id
        }
      });
    },
    async openEditReminder(data) {
      await this.getReminderById(data.id);
      this.showModal('ModalContentEditReminder');
    },
    async openDeleteReminder(data) {
      await this.getReminderById(data.id);
      this.showModal('ModalContentDeleteReminder');
    },
    getOrdering() {
      return this.ordering === 'desc' ? 'asc' : 'desc';
    },
    emitSort(orderCondition) {
      this.sorted = orderCondition;
      this.$emit('sort', { orderDirection: this.ordering, orderCondition });
      this.ordering = this.getOrdering();
    },
    getAmountClass(row) {
      if (row.amount < 0) {
        return 'table-transaction-expense';
      } else {
        return 'table-transaction-income';
      }
    },
    getBalanceClass(row) {
      if (row.balance < 0) {
        return 'table-transaction-expense';
      } else {
        return 'table-transaction-income';
      }
    }
  }
};
</script>

<style lang="scss">
.post-pin {
  display: flex;
  justify-content: center;
  align-content: center;
  i {
    transform: rotate(45deg);
    color: #ffc107;
  }
}
.table-class {
  .manager-member {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .manager-badge {
    margin-left: 8px;
  }
  .notification-status {
    min-width: 120px;
    position: relative;
    i {
      position: absolute;
      right: 0;
    }
    .fa-check {
      color: var(--primary-color);
      font-size: 20px;
    }
    .fa-exclamation-circle {
      color: #c03;
      font-size: 20px;
    }
  }

  .btn--new {
    background-color: #ecb043;
  }
  .table td {
    vertical-align: unset;
    // truncate text
    // max-width: 20vw;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  .page-item > .page-link {
    color: black;
  }
  .page-item.active .page-link {
    background-color: var(--primary-color-lighten) !important;
    border-color: var(--primary-color-lighten) !important;
  }
  .page-link:focus {
    // box-shadow: 0 0 0 0.1rem var(--primary-color-lighten) !important;
    box-shadow: none !important;
  }

  .btn-wrapper {
    text-align: center;
    vertical-align: middle;
  }

  .btn:focus {
    outline: 0;
    box-shadow: 0 0 0 0;
  }
  .cell {
    text-align: center;
    vertical-align: middle;
  }

  .btn--mod {
    margin: auto 3px auto 3px;
  }

  .header-priority-wrapper {
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
  }

  .table thead th {
    vertical-align: unset;
  }

  .btn-finances-details {
    height: 24px;
    padding: 1px 6px 4px 6px;
    font-size: 0.9rem;
  }

  .center-content {
    display: flex;
    justify-content: center;
  }
}

.cell--mod {
  display: flex;
  justify-content: center;
}
.cell--mod--left {
  display: flex;
}

td:focus,
th:focus {
  outline: none;
}

.table-transaction-expense {
  color: #cc0000;
}
.table-transaction-income {
  color: #00ab16;
}

.ticket-buttons {
  z-index: 999;
}

.btn-table {
  background-color: #d9d9d9 !important;
}
</style>
